import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  doctorsSelect: {
    data: [],
    isLoading: false,
    message: null,
  },
  summaryProcedures: {
    data: [],
    isLoading: false,
    message: null,
  },
  params: {
    doctorId: "",
    startDate: "",
    endDate: "",
  },
  // pageSize: "5",
  // page: "1",
  // totalPages: 1,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const summaryProcedureSlice = createSlice({
  name: "summaryProcedure",
  initialState,
  reducers: {
    loadingDoctorsSelect: (state) => {
      state.doctorsSelect.isLoading = true;
      state.doctorsSelect.message = null;
    },
    loadedDoctorsSelect: (state, { payload }) => {
      state.doctorsSelect.data = payload.doctors;
      state.doctorsSelect.isLoading = false;
      state.doctorsSelect.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedDoctorsSelect: (state, { payload }) => {
      state.doctorsSelect.isLoading = false;
      state.doctorsSelect.message = {
        type: "error",
        text: payload,
      };
    },
    loadingSummaryProcedures: (state) => {
      state.summaryProcedures.isLoading = true;
      state.summaryProcedures.message = null;
    },
    loadedSummaryProcedures: (state, { payload }) => {
      state.summaryProcedures.data = payload.summaryProcedures;
      state.summaryProcedures.isLoading = false;
      // state.page = payload.page;
      // state.totalPages = payload.totalPages;
      state.summaryProcedures.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedSummaryProcedures: (state, { payload }) => {
      state.summaryProcedures.isLoading = false;
      state.summaryProcedures.message = {
        type: "error",
        text: payload,
      };
    },
    changeParams: (state, { payload }) => {
      state.params = payload;
    },
    resetParams: (state) => {
      resetState(state, ["params"]);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingDoctorsSelect,
  loadedDoctorsSelect,
  failedDoctorsSelect,
  loadingSummaryProcedures,
  loadedSummaryProcedures,
  failedSummaryProcedures,
  changeParams,
  resetParams,
} = summaryProcedureSlice.actions;
